module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-crying-dark-bb83e537350e2e99d28ca5aebe9e451d.svg";